import { render, staticRenderFns } from "./verify_list.vue?vue&type=template&id=3163aa54&"
import script from "./verify_list.vue?vue&type=script&lang=js&"
export * from "./verify_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports